export const resources_app_elements = {
  en: {
    translation: {
      Menu: {
        position: 'Position',
        content: 'Content',
        ElOrder: 'Order overlaps of elements',
        presentation_OS: 'OpenSankey is a web application that makes it easy to create Sankey diagrams.\n\n It\'s available free of charge, and includes simple functions for creating nodes, flows and labeling them to aggregate or filter their display on the diagram.\n\n The 15-node limit for use without an account can be lifted by creating a license-free account.\n\n',
        presentation_OS_limit_node: 'The 15-node limit for use without an account can be lifted by creating a free account.\n\n',
        Aucun: 'None',
        confSankey: 'Sankey\'s configuration',
        MEP: 'Drawing zone',
        background: 'Background',
        Noeuds: 'Nodes',
        EN: 'Nodes\' tags',
        EdN: 'Editing nodes',
        flux: 'Links',
        EF: 'Links\' tags',
        EdF: 'Editing links',
        ED: 'Data\'s tags',
        Leg: 'Legends',
        LegX: 'Horizontal',
        LegY: 'Vertical',
        LegWidth: 'Width',
        larg: 'Width',
        haut: 'Height',
        Fichiers: 'Files',
        mep: 'Layout',
        formation: 'Tutorials',
        Exemples: 'Demos',
        Aide: 'Help',
        ouvrir: 'Open',
        launch: 'Launch',
        enregistrer: 'DL',
        exporter: 'Export',
        exporter_to: 'To ',
        preference: 'Preferences',
        esn: 'Edit style',
        rc: 'Keyboard Shortcuts',
        as: 'Additional Help',
        doc: 'Doc.',
        ca: 'Path',
        annuler: 'Cancel',
        submit: 'Submit',
        pdd: 'Publish/Update diagram',
        fmep: 'Layout file',
        ad: 'Apply the layout',
        ns: 'Style name',
        BgC: 'Color',
        Tags: 'Tags',
        PosNoeud: 'Node geometry',
        PosFlux: 'Flux Geometry',
        attrNode: 'Node Attributes',
        attrFlux: 'Flux Attributes',
        tagLevel: 'Level of Detail',
        tagNode: 'Node Tags',
        tagFlux: 'Flux Tags',
        tagData: 'Data Tags',
        tagFlux_assign: 'Assign a link tag',
        SaveJSON: 'Save as JSON',
        SaveValue: 'Save with links\' values',
        VisibleElement: 'Only save visible elements',
        VisibleTagElement: 'Only save elements with selected_tags',
        templates: 'Templates',
        licence: 'Licences',
        display_scale: 'Display link scale',
        fontSize: 'Font size',
        file: 'Files',
        diagramme: 'Diagrams',
        edition: 'Formatting',
        demo: 'Sankeylib',
        aide: 'Help',
        filter: 'Filter',
        toolbar: 'Tools',
        check: 'Check',
        last_save: 'Last save',
        style: 'Styles',
        close: 'Close',
        Elements: 'Eléments',
        Etiquettes: 'Editing tags',
        reinit: 'Reset',
        amp_short: 'Layout',
        ajustH: 'Adjust. H',
        ajustV: 'Adjust. V',
        multiValue: 'Multiple values among seleced elements',
        undo: 'Undo',
        redo: 'Redo',
        reset_all_attr: 'Reset all attributes overwrite',
        reset_attr: 'Del. overwrite : ',
        empty_config: 'Click on a button on the right to configure diagram elements',
        style_attr_applicated: 'Style attributes applicated',
        sankey_file_name: 'File name',
        support: 'Contact',
        c_support: 'Contact the support',
        rth_support: 'We are here to help you',
        support_explication: 'If you encounter a technical problem, write to us at [] and we will deal with your request as quickly as possible.',
        suppr: 'Delete',
        load_file: 'Load file',
        compute_file: 'Computing',
        loaded_file: 'File loaded',
        failure_file: 'Loading failed',
        selectNodeAttrubutedToTag: 'Select all nodes having this tag',
        selectLinkAttrubutedToTag: 'Select all links having this tag',
        node_label_sep: 'Name delimiter',
        node_label_sep_pos: 'Segment to display',
        before: 'Before',
        after: 'After',
        from_new: 'Empty diagram',
        from_model: 'From a model',
        new_excel_template: 'Blank Excel file',
        open_json: 'JSON',
        open_excel: 'Excel',
        open_sankeymatic: 'SankeyMATIC',
        format_converter: 'Convert format',
        title_pref: 'User personnal themes',
        lang: 'Language',
        new: 'New',
        pref_title_sub_menu: 'Choose sub-menu visible in configuration menu',
        overcharge_style_value: 'Value of the variable override the value from the style',
        group: 'Tag group',
        color: 'Color',
        type_selection: 'Multi selection',
        LegBgOpacity: 'Opacity',
        LegBgBorder: 'Border',
        LegStickDrawing: 'Stick to diagram',
        LegBgColor: 'Color',

        Config: {
          type_data: 'Structure/Data',
          type_style: 'Formatting',
          presentation: 'Tags/Views',
          element_graph: 'Graph',
          element_node: 'Node',
          element_flow: 'Flow',
          element_node_tag: 'Node Label',
          element_flow_tag: 'Flow Label',
          element_level_tag: 'Hierarchy',
          element_data: 'Data',
          element_data_tag: 'Data Label',
          title_table: 'Flow Table',
          title_graph: 'Graph',
          title_legend: 'Legend',
          title_node: 'Nodes',
          title_flow: 'Flows',
          title_elements: 'Eléments',
          title_node_tag: 'Node Label Editing',
          title_flow_tag: 'Flow Label Editing'
        },

        // ✅ Transformation reste car non géré par une config spécifique
        Transformation: {
          verticalize_short: 'Transpose',
          verticalize: 'Transpose diagram',
          amp_short: 'Layout',
          amp: 'Change the layout',
          amp_import: 'From other diagram',
          amp_manual: 'Positioning',
          trans_topo: 'Topological',
          fmep: 'Source diagram',
          sourceType: 'Source',
          sourceFile: 'File',
          sourceView: 'View',
          ad: 'Apply',
          undo: 'Cancel',
          Shortcuts: 'Shortcuts selections',
          unSelectAll: 'None',
          selectAll: 'All',
          selectDefault: 'Default',
          Topology: 'Additions and deletions',
          Geometry: 'Sizes and positions',
          Attribut: 'Attributes',
          Tags: 'Tags',
          Values: 'Link values',
          Views: 'Views',
          freeLabels: 'Text boxes',
          ZdT: 'TBox',
          Ajouts: 'Additions',
          Suppressions: 'Deletions',
          addFreeLabel: 'Add TBox',
          removeFreeLabel: 'Del. TBox',
          attrFreeLabel: 'Attr. TBox',
          posFreeLabel: 'Pos. TBox',
          Styles: 'Styles',
          addNode: 'Aj. Nodes',
          removeNode: 'Sup. Nodes',
          addFlux: 'Aj. Flux',
          removeFlux: 'Sup. Flux',
          PosOut: 'Nodes',
          posFlux: 'Flux',
          attrNode: 'Nodes',
          attrFlux: 'Flux',
          tagLevel: 'Levels of detail',
          tagNode: 'Node tags',
          tagFlux: 'Flux tags',
          tagData: 'Data tags',
          tagNode_assign: 'Assign a label',
          tagFlux_assign: 'Assign a label',
          attrGeneral: 'Drawing area',
          scale: 'Scale',
          updateTags: 'Update',
          elementsTitle: 'Eléments',
          tagGroupsTitle: 'Tag groups',
          dataTitle: 'Data',
          title: 'Layout',
          oher_file: 'Other file',
          tooltips: {
            Shortcuts: 'Shortened selection of attributes to transfer from imported sankey',
            Topology: 'Transfer added/deleted node/links from the imported sankey to current',
            Geometry: 'Transfer nodes & flux position attributes from the sankey  imported to the current',
            Attribute: 'Transfer attributes of nodes and links from imported sankey to current',
            Tags: 'Transfer node/links tags from imported sankey to current',
            Values: 'Transfer the values of the links of the imported sankey to the current',
            tagLevel: 'Transfer nodes details of imported sankey to current',
            attrGeneral: 'Transfer the attributes of the drawing area of the imported sankey to the current',
            Styles: 'Transfer element styles from the imported sankey to the current',
          }
        },
        Styles: 'Styles',

        tooltips: {
          // ❌ SUPPRIMÉ : noeud.* et flux.* (maintenant dans ELEMENTS_SELECTION_CONFIG)

          LegX: 'Horizontal distance (in px) between the upper left corner of the legend and the upper left corner of the window',
          LegY: 'Vertical distance (in px) between the upper left corner of the legend and the upper left corner of the window',
          LegWidth: 'Width (in px) for the legend space',
          BgC: 'Change the background color of the interactive graphic space',
          checkpoint: 'Local data saving on the browser (cache memory)',
          fontSize: 'Change the size of the font in the legend',
          node_label_sep: 'String of text that will be used to hide some part of a node label, exemple: separator is " - " and node name is "node1 - subinfo" the node label displayed in the drawing area will be "node1"',
          node_label_sep_pos: 'Select wich part of nodes label to display (before or after separator)',
          new: 'Create a new Sankey diagram from scratch or using a template.',
          ouvrir: 'Open a file',
          enregistrer: 'Save as',
          preference: 'Set & Modify your own applications settings (saved in your OpenSankey+ account)',
          amp: 'Modify the layout of the diagram',
          verticalize: 'Transpose the diagram: swap horizontal and vertical axes (positions, link directions, shapes)',
          style: 'Define style of nodes or links',
          DisplayWelcome: 'Display welcome message',
          doc: 'Open the documentation',
          support: 'Contact the support',
          tuto: 'Explore tutorials',
          LegBgOpacity: 'Choose background color',
          LegBgBorder: 'Add a border to the legend area',
          LegStickDrawing: 'Follow zoom in drawing area',
          LegBgColor: 'Choose background color opacity',
          old_app: 'Redirect to the legacy version of OpenSankey',
          SpreadSheet: 'Representation and editing of the diagram in a spreadsheet',
          ConfigMenu: 'Editing the diagram through a configuration menu',
          sankey_file_name: 'Name of diagram : ',
          style_attr_applicated: 'Select which attributes in the style can be applicated, it also unlock the corresponding input',
        },
      },

      SpreadSheet: {
        paste: 'Paste'
      },

      MEP: {
        onBlur: 'Value is applied when we leave the input or we press enter',
        Echelle: 'Scale',
        leg_layout: 'Layout',
        leg_layout_text: 'Text',
        leg_layout_background: 'Background',
        leg_pos: 'size & position',
        leg_info: 'Informations',
        leg_show_dataTags: 'DataTags',
        leg_show_constraints: 'Constraints doc',
        leg_show_data_type: 'Data type',
        leg_data_calculated: 'Calculated data',
        leg_data_collected: 'Collected data',
        leg_show_info_link_void: 'Show info concerning null link',
        links_size: 'Links size',
        MaxFlux: 'Max',
        MinFlux: 'Min',
        link_size_limit: 'Link size limit',
        TCG: 'Grid',
        TCG_shift: 'Shift',
        MN: 'Nodes magnetic to grid',
        SLIP: 'Legend',
        AN: 'Align to grid',
        Horizontal: 'Horizontal spacing between nodes',
        Vertical: 'Vertical spacing between nodes',
        PA: 'Auto position',
        PA_action: 'Apply',
        factExpH: 'Horizontal expansion factor',
        factExpV: 'Vertical expansion factor',
        stretchH: 'Apply',
        stretchV: 'Apply',
        reInitDY: 'Réinitialiser',
        GestionCouleurs: 'Color Management',
        columnsParameters: 'Column parameters',
        Style: 'Styles',
        linkStyleVisual: 'Flow appearance',
        linkStyleLabels: 'Flow labels',
        nodeStyleVisual: 'Node appearance',
        nodeStyleLabels: 'Node labels',
        ZoneDessin: 'Drawing zone',
        Positionnement: 'Positioning',
        positioningMode: 'Positioning mode',
        autoX: 'Automatic horizontal positioning',
        parametricMode: 'Fixed spacing',
        absoluteMode: 'Fixed coordinates',
        importExport: 'Import/export nodes',
        importExportClose: 'Import/export close',
        importExportAboveBelow: 'Import/export top/bottom',
        show_legend_free_value: 'Value is contained in an interval',
        legend_dashed_links: 'Unknown flow value',
        hide_leg: 'Hide the legend',
        show_leg: 'Show the legend',
        tooltips: {
          Echelle: 'Change the scale of the links and nodes',
          MaxFlux: 'Change the maximum size (in pixels) for the display of the links',
          MinFlux: 'Change the minimum size (in pixels) for the display of the links',
          TCG: 'Size of the background grid tiles (in pixels)',
          MN: 'Dragged nodes move by "step" instead of continuously following the mouse',
          SLIP: 'Enable/Disable the presence of the legend when palette of color from elements tags are displayed',
          GV: 'Enable or disable the display of the background grid',
          AN: 'Automatically arrange nodes: ie come and paste the upper left corner of the nodes on the nearest grid corner',
          EEN_h: 'Default horizontal distance (in pixel) between nodes for automatic positioning',
          EEN_v: 'Default vertical distance (in pixel) between nodes for automatic positioning',
          PA: 'Perform an automatic positioning of the nodes according to the specified default distances',
          BgC: 'Change the background color of the interactive graphic space',
          factExpH: 'Modifies the horizontal expansion factor: applying the factor multiplies the horizontal deviation of each node from the leftmost one by the input factor',
          factExpV: 'Modifies the vertical expansion factor: applying the factor multiplies the vertical deviation of each node from the highest one by the input factor',
          reInitDY: 'Reset',
          columnsParameters: 'Column parameters',
          positioningMode: 'Positioning mode',
          autoX: 'Automatic horizontal positioning',
          parametricMode: 'Constant vertical intervals',
          absoluteMode: 'Fixed anchor points',
          importExport: 'Import/export nodes',
          importExportClose: 'Import/export near the node',
          importExportAboveBelow: 'Import/export at the top and bottom of the diagram',
        }
      },

      Tags: {
        Nom: 'Name',
        Leg: 'Legend',
        tags: 'Tags',
        Bannière: 'Type',
        Position: 'Position',
        Unique: 'Unique',
        Multiple: 'Multiple',
        Unit: 'Unit',
        Niveau: 'Level',
        Visible: 'Visible',
        Couleur: 'Color',
        Forme: 'Shape',
        GE: 'Tags Group',
        selct: 'Selected',
        EGE: 'Tags group edition',
        EEG: 'Tags edition',
        tooltips: {
          pal: 'Apply a random color palette for the tags of the selected group',
          pal_shuffle: 'Change the order of the colors applied to the tags of the selected group',
          pal_std: 'Choose a standard color palette for the tags of the selected group',
          add: 'Add a tag to the selected group',
          add_grp: 'Add a tag group',
          rm: 'Delete the tag',
          rm_grp: 'Delete this tag group',
          nom: 'Rename the current tag',
          nom_grp: 'Rename this tag group',
          leg_grp: 'Activate or not the legend on the filtering of this group of tags and therefore the colors associated with the tags of this group',
          visible: 'Choose to make visible or not the nodes associated with this tag',
          couleur: 'Change the color of the current tag',
          forme: 'Choose the shape of the nodes associated with this tag',
          banner: 'Choose the type of dropdown menu on the filtering of this tag group (None / Single / Multiple / LevelTags)',
          up: 'Move the tag group up in the node filtering menu',
          down: 'Move the tag group down in the node filter menu'
        }
      },

      Banner: {
        unitary_view: 'Views',
        title_data_type: 'Data displayed',
        data: 'Data',
        filter: 'Filter',
        fdf: 'Link filtering',
        fdn: 'Legend and filters',
        ndd: 'Hierarchy',
        ndd_one: 'Hierarchy',
        ndd_lst: 'Tags groups',
        ndd_chk: 'Apply the groups\' colors',
        sdr: 'Data type',
        sdd: 'Data selection',
        tl: 'Download',
        rslt: 'Download results',
        p_aff: 'Display settings',
        p_aff_aff_links: 'Links display settings',
        p_aff_filtre_links: 'Links display filter',
        type_value: 'Links value type',
        structure: 'Structure',
        collected_data: 'Collected',
        collected_data_label: 'Computed with data labels',
        reconciled: 'Computed',
        only_data: 'Values',
        free_interval: 'Interval',
        free_value: 'Possible values',
        indetermined_value: 'Interval display',
        filtre: 'Threshold for links dislay',
        fl: 'Threshold for labels display',
        fn: 'Null Link Visible',
        visible: 'Visible',
        hlp_1: 'Sankey diagram',
        hlp_1_txt_2: 'Choose the displayed level of aggregation for all the diagram\'s nodes',
        hlp_1_txt_3: 'Filters can be used to display only parts of the diagram. To do this use the selectors',
        hlp_1_txt_4: 'Different color palettes can be used to color nodes and links using the Color Palette selector',
        hlp_1_txt_5: 'The diagram structure (without link thickness) can be displayed by checking Diagram structure',
        hlp_1_txt_6: 'The diagram can be adjusted on screen by checking Adjust on screen',
        hlp_1_txt_7: 'To get information about each link, press shift and move the mouse over the link',
        hlp_1_txt_8: 'Links visualisations settings',
        hlp_1_txt_9: 'Dropdown to filter node/link/data according to their group tag or to choose to display the diagram with color palette from a tag group.',
        tooltipAdjustH: 'Adjust horizontaly drawing area to the screen size',
        tooltipAdjustV: 'Adjust verticaly drawing area to the screen size',
        tooltipTranspose: 'Transpose the diagram: swap horizontal and vertical axes',
        tooltipStructure: 'Visualisation settings for the diagram\'s structure',
        tooltipSelection: 'Allows to drag an element',
        tooltipHelp: 'Show the help dialog',
        posMode_parametric: 'Constant vertical offset mode',
        posMode_absolute: 'Absolute coordinate mode',
        tooltipAjoutNode: 'Adds a node to the mouse click',
        tooltipLiason: 'Allows you to select the edit mode to draw nodes and flows or the selection mode to select nodes and flows in order to modify their attributes.',
        select_sibling: 'Select siblings',
        fullscreen: 'Put the window in fullscreen',
        quit_fullscreen: 'Exit the fullscreen',
        hlp_node_tag_filter: 'Filter nodes and apply color of tagds',
        hlp_link_tag_filter: 'Filter link and apply color of tagds',
        hlp_data_tag_filter: 'Choose data and apply color of tagds',
        open_configuration_menu: 'Open configuration menu.'
      },

      useTemplate: 'Use this template',
      DisplayWelcome: 'Welcome',
      dontSeeAgain: 'Don\'t show again',
      scale: 'Scale',
      useTutoJSON: 'Open',
      useTutoExcel: 'Open Excel',
      menuTuto: 'Open tutorials menu',
      desire_to_know_more: 'Learn more',
      contribute_to_os: 'En savoir +',
      legal: 'Legal informations',
      tdr: 'All right reserved',
      fullscreen: 'Activate fullscreen',
      exitFullscreen: 'Exit fullscreen',
      Avancé: 'Advanced',
      separator_interval: ',',
      sep_decimal: '.',
      diaporama: 'Presentation',
      start: 'Start',
      tooltip: {
        dontSeeAgain: 'By checking this box, the welcome screen will no longer appear on the next page load. To display this welcome screen again, go to Help->Home.',
        diaporama: 'Presentation of the various features of the tool, from the most basic to the most advanced as well as mouse/keyboard combination for edition.',
        start: 'Start drawing your flows. To do this, click in the drawing area, drag without releasing, then release.'
      },
      color_lock: {
        locked: 'Custom color — this color is fixed and will not be overridden by the element\'s own color',
        unlocked: 'Inherits the element\'s color (node, link or text zone) — click to lock a custom color'
      }
    }
  },
  //=======================================================
  //FR
  //=======================================================
  fr: {
    translation: {
      Menu: {
        position: 'Position',
        content: 'Contenu',
        ElOrder: 'Ordre d\'affichage',
        presentation_OS: 'OpenSankey et une application web qui permet de réaliser simplement des diagrammes de Sankey.\n\nCelle-ci est accessible gratuitement, et inclut les fonctionnalités simples de création de nœuds, de flux et leur étiquetage afin d\'agréger ou de filtrer leur affichage sur le diagramme.\n\n',
        presentation_OS_limit_node: 'La création d\'un compte gratuit permet de lever la limitation de 15 nœuds fixée pour un usage sans compte.\n\n',
        Aucun: 'Aucun',
        confSankey: 'Configuration du Sankey',
        MEP: 'Zone de dessin',
        background: 'Fond',
        Noeuds: 'Noeuds',
        EN: 'Étiquettes des noeuds',
        EdN: 'Édition des noeuds',
        flux: 'Flux',
        EF: 'Étiquettes des flux',
        EdF: 'Édition des flux',
        ED: 'Étiquettes des données',
        Leg: 'Légende',
        LegX: 'Horizontale',
        LegY: 'Verticale',
        LegWidth: 'Largeur',
        larg: 'Largeur',
        haut: 'Hauteur',
        Fichiers: 'Fichiers',
        edition: 'Mise en forme',
        formation: 'Tutoriels',
        Exemples: 'Sankeythèque',
        Aide: 'Aide',
        ouvrir: 'Ouvrir',
        launch: 'Lancer',
        file_converter: 'Convertisseur de fichiers',

        select_file: 'Fichier à convertir',
        enregistrer: 'Enregis.',
        new: 'Nouv.',
        exporter: 'Exporter',
        exporter_to: 'En',
        preference: 'Préférences',
        Elements: 'Éléments',
        Etiquettes: 'Étiquettes',
        amp_import: 'Depuis autre diagramme',
        amp_short: 'Trans.',
        ajustH: 'Ajust. H',
        ajustV: 'Ajust. V',

        multiValue: 'Différentes valeurs dans la sélection',

        undo: 'Annuler',
        redo: 'Refaire',

        esn: 'Editions des styles',
        esn_labels: 'Libellés des noeuds',
        esf_labels: 'Libellés des flux',
        container_style: 'Style des zones de textes',

        rc: 'Raccourcis clavier',
        as: 'Aide Supplémentaire',
        doc: 'Doc.',
        ca: 'Chemin d\'accés',
        annuler: 'Annuler',
        submit: 'Ok',
        pdd: 'Publier/Mettre à jour le diagramme',
        fmep: 'Autre diagramme',
        ad: 'Appliquer la transformation',
        ns: 'Nom du Style',
        BgC: 'Couleur',
        Tags: 'Etiquettes',
        Values: 'Valeurs',
        topoNode: 'des Noeuds',
        topoFlux: 'des Flux',
        tagLevel: 'Niveaux de détail',
        tagNode: 'Etiquette Noeuds',
        tagFlux: 'Etiquette Flux',
        tagData: 'Etiquette Données',
        tagNode_assign: 'Assigner étiquettes',
        tagFlux_assign: 'Assigner étiquettes',
        SaveJSON: 'Enregistrer JSON',
        SaveValue: 'Enregistrer avec les valeurs des flux',
        VisibleElement: 'Enregistrer que les éléments visibles',
        VisibleTagElement: 'Enregistrer que les éléments avec étiquettes sélectionnées',
        templates: 'Modèles',
        licence: 'Licences',
        display_scale: 'Échelle',
        fontSize: 'Taille police',
        file: 'Fichiers',
        demo: 'Sankeythèque',
        aide: 'Aide',
        filter: 'Filtres',
        toolbar: 'Outils',
        check: 'Sauv.',
        last_save: 'Dernière sauvegarde',
        style: 'Styles',
        close: 'Fermer',
        reset_all_attr: 'Suppr. toutes les surcharges',
        reset_attr: 'Suppr. surcharge : ',
        empty_config: 'Cliquez sur les boutons de droite pour configurer les éléments du diagramme',
        sankey_file_name: 'Nom du fichier',
        style_attr_applicated: 'Attributs appliqués du style',
        support: 'Contact',
        c_support: 'Contacter le support',
        rth_support: 'Nous sommes là pour vous aider',
        support_explication: 'Si vous rencontrez un problème technique, écrivez-nous à [], nous traiterons votre demande dans les meilleurs délais.',
        suppr: 'Supprimer',
        rand_node_color: 'Couleurs aléatoires noeuds',
        rand_link_color: 'Couleurs aléatoires flux',
        load_file: 'Lecture du fichier',
        compute_file: 'En traitement...',
        open_file: 'Charger fichier',
        download_file: 'Télécharger fichier',
        reinit: 'Réinitialiser',
        loaded_file: 'Chargement terminé',
        failure_file: 'Chargement échoué',
        choseTransforDifficulty: 'Types d\'éléments',
        selectNodeAttrubutedToTag: 'Sélectionne les noeuds possédant cette étiquette',
        selectLinkAttrubutedToTag: 'Sélectionne les flux possédant cette étiquette',
        node_label_sep: 'Délimiteur de nom',
        node_label_sep_pos: 'Segment à afficher',
        before: 'Avant',
        after: 'Après',
        from_new: 'Nouveau diagramme',
        from_model: 'A partir d\'un modèle',
        new_excel_template: 'Fichier Excel vierge',
        open_json: 'JSON',
        open_excel: 'Excel',
        format_converter: 'Convertisseur de format',
        open_sankeymatic: 'SankeyMATIC',
        title_pref: 'Thèmes utilisateur',
        lang: 'Langue',
        pref_title_sub_menu: 'Choix des sous-menus visibles dans l\'interface',
        overcharge_style_value: 'La valeur de la variable surcharge celle du style',
        group: 'Groupe d\'étiquettes',
        color: 'Couleur',
        oher_file: 'Autre fichier',
        type_selection: 'Multi sélection',
        LegBgOpacity: 'Opacité',
        LegBgBorder: 'Bordure',
        LegBgColor: 'Couleur',
        LegStickDrawing: 'Solidaire de la zone de dessin',


        Config: {
          type_data: 'Structure/Données',
          type_style: 'Mise en forme',
          presentation: 'Etiquettes/Vues',

          element_graph: 'Graphe',
          element_legend: 'Légende',
          element_node: 'Noeuds',
          element_flow: 'Flux',
          element_node_tag: 'Étiq. Noeud',
          element_flow_tag: 'Étiq. Flux',
          element_level_tag: 'Hiérarchie',

          element_data: 'Données',
          element_data_tag: 'Étiq. Données',

          title_table: 'Tableau des flux  ',
          title_graph: 'Graphe',
          title_legend: 'Légende',
          title_node: 'Noeuds',
          title_flow: 'Flux',
          title_elements: 'Eléments',
          title_node_tag: 'Édition des étiquettes de noeuds',
          title_flow_tag: 'Édition des étiquettes de flux',

          // title_context_da: 'Graphe',
          // title_context_node: 'Noeuds',
          // title_context_flow: 'Flux',

          // title_style_da: 'Graphe',
          // title_style_node: 'Noeuds',
          // title_style_flow: 'Flux',
        },
        Transformation: {
          verticalize_short: 'Transposer',
          verticalize: 'Transposer le diagramme',
          amp_short: 'M.E.P',
          amp: 'Modifier la mise en page',
          amp_import: 'Depuis autre diagramme',
          amp_manuelle: 'Positionnement des noeuds',
          trans_topo: 'Topologiques',
          fmep: 'Diagramme source',
          sourceType: 'Source',
          sourceFile: 'Fichier',
          sourceView: 'Vue',
          ad: 'Appliquer',
          undo: 'Annuler',
          Shortcuts: 'Raccourcis sélections',
          unSelectAll: 'Aucun',
          selectAll: 'Tout',
          selectDefault: 'Défaut',
          Topology: 'Ajouts et suppressions',
          Geometry: 'Tailles et positions',
          Attribut: 'Attributs',
          Tags: 'Etiquettes',
          Values: 'Valeurs des flux',
          Views: 'Vues',
          freeLabels: 'Zones de texte',
          ZdT: 'Zones de texte',
          Ajouts: 'Ajouts',
          Suppressions: 'Suppressions',
          addFreeLabel: 'Aj. ZdT',
          removeFreeLabel: 'Sup. ZdT',
          attrFreeLabel: 'Attr. ZdT',
          posFreeLabel: 'Pos. ZdT',
          Styles: 'Styles',
          addNode: 'Aj. Noeuds',
          removeNode: 'Sup. Noeuds',
          addFlux: 'Aj. Flux',
          removeFlux: 'Sup. Flux',
          PosNoeud: 'Noeuds',
          posFlux: 'Flux',
          attrNode: 'Noeuds',
          attrFlux: 'Flux',
          tagLevel: 'Niveaux de détail',
          tagNode: 'Étiquettes nœud',
          tagFlux: 'Étiquettes flux',
          tagData: 'Étiquettes données',
          tagNode_assign: 'Assigner étiquettes',
          tagFlux_assign: 'Assigner étiquettes',
          attrGeneral: 'Attributs généraux',
          scale: 'Échelle',
          updateTags: 'Mise à jour',
          elementsTitle: 'Éléments',
          tagGroupsTitle: 'Groupes d\'étiquettes',
          dataTitle: 'Données',
          title: 'Mise en page',
          tooltips: {
            Shortcuts: 'Raccourcie de sélection des attributs à transférer du sankey importé',
            Topology: 'Transfert des noeud/flux ajoutés/supprimés du sankey importé vers l\'actuel',
            Geometry: 'Transfert les attributs de positionnement des noeuds et flux du sankey importé vers l\'actuel',
            Attribut: 'Transfert les attributs des noeuds et flux du sankey importé vers l\'actuel',
            Tags: 'Transfert les étiquettes de noeud et flux du sankey importé vers l\'actuel',
            Values: 'Transfert les valeurs des flux du sankey importé vers l\'actuel',
            tagLevel: 'Transfert les nieveaux de détails du sankey importé vers l\'actuel',
            attrGeneral: 'Transfert les attributs de la zone de dessin du sankey importé vers l\'actuel',
            Styles: 'Transfert les styles des éléments du sankey importé vers l\'actuel',
          }
        },
        Styles: 'Styles',
        tooltips: {
          LegX: 'Ecart horizontal (en px) entre le coin supérieur gauche de la légende par rapport au coin supérieur gauche de la fenêtre',
          LegY: 'Ecart vertical (en px) entre le coin supérieur gauche de la légende par rapport au coin supérieur gauche de la fenêtre',
          LegWidth: 'Largeur (en px) de l\'espace de la légende',
          BgC: 'Changer la couleur fond de l\'espace graphique interactif',
          checkpoint: 'Sauvegarde locale sur le navigateur (mémoire cache)',
          fontSize: 'Modifie la taille de la police pour la légende',
          node_label_sep: 'Chaine de caractère qui permettra de masquer une partie d\'un label de noeud, exemple : le séparateur est " - " et le nom du noeud est " noeud1 - sousinfo" alors le label du noeud affiché dans la zone de dessin sera "noeud1"',
          node_label_sep_pos: 'Choisir si l\'on affiche le label des noeuds qui ce situe avant ou après le séparateur',
          new: 'Créez un nouveau diagramme de Sankey à partir de zéro ou en utilisant un modèle.',
          ouvrir: 'Ouvrir un fichier',

          enregistrer: 'Enregistrer sous',
          preference: 'Créez & Modifiez vos paramètres personnalisés d\'utilisation (liés à votre compte OpenSankey+)',
          amp: 'Modifier la mise en page du diagramme',
          verticalize: 'Transposer le diagramme : inverser les axes horizontal et vertical (positions, sens des flux, formes)',
          style: 'Définir des styles par groupe de noeuds ou de flux',
          DisplayWelcome: 'Afficher le message d\'accueil',
          doc: 'Ouvrir la documentation',
          support: 'Contacter le support',
          tuto: 'Explorer les tutoriels',
          LegBgOpacity: 'Modifie l\'opacité de la couleur de fond de la légende',
          LegBgBorder: 'Ajoute une bordure à la légende',
          LegStickDrawing: 'Si sélectionné,Le zoom agit aussi sur la légende',
          LegBgColor: 'Moddifie la couleur de fond de la légende',
          old_app: 'Redirige vers la version précédente de OpenSankey',
          SpreadSheet: 'Représentation et édition du diagramme dans une spreadsheet',
          ConfigMenu: 'Edition du diagramme dans un menu de configuration',
          sankey_file_name: 'Nom du diagramme : ',
          style_attr_applicated: 'Choisis quelle attributs peuvent être appliqués par ce style, dévérouille l\'input correspondant',

        },
      },
      SpreadSheet: {
        paste: 'Coller'
      },
      MEP: {
        onBlur: 'La valeur sera appliqué dès que l\'on quitte l\'input ou presser la touche entrée',
        Echelle: 'Echelle',
        links_size: 'Taille des flux',
        leg_layout: 'Mise en forme',
        leg_layout_text: 'Texte',
        leg_layout_background: 'Fond',
        leg_pos: 'Taille et position',
        leg_info: 'Informations',
        leg_show_dataTags: 'Etiquettes de données',
        leg_show_constraints: 'Explication contraintes',
        leg_show_data_type: 'Type de données',
        leg_data_calculated: 'Données calculées',
        leg_data_collected: 'Données collectées',
        leg_show_info_link_void: 'Affiche info concernant les flux nuls',

        MaxFlux: 'Max',
        MinFlux: 'Min',
        link_size_limit: 'Taille limite des flux',
        TCG: 'Quadrillage',
        TCG_shift: 'Espacement',
        MN: 'Noeuds aimantés à la grille',

        SLIP: 'Légende',
        AN: 'Aligner sur grille',
        Horizontal: 'Ecartement horizontal',
        Vertical: 'Ecartement vertical',
        PA: 'Positionnement auto',
        PA_action: 'Appliquer',
        factExpH: 'Facteur d\'expansion horizontale',
        factExpV: 'Facteur d\'expansion verticale',
        stretchH: 'Appliquer',
        stretchV: 'Appliquer',
        reInitDY: 'Réinitialiser',
        columnsParameters: 'Paramètres des colonnes',
        Style: 'Style des éléments',
        linkStyleVisual: 'Formes des flux',
        linkStyleLabels: 'Libellés des flux',
        nodeStyleVisual: 'Formes des noeuds',
        nodeStyleLabels: 'Libellés des noeuds',
        GestionCouleurs: 'Gestion des couleurs',
        ZoneDessin: 'X',
        Positionnement: 'Positionnement',
        positioningMode: 'Mode de positionnement',
        autoX: 'Positionnement horizontal automatique',
        parametricMode: 'Ecarts fixes',
        absoluteMode: 'Coordonnées fixes',
        importExport: 'Noeuds imports exports',
        importExportClose: 'Import/export proche',
        importExportAboveBelow: 'Import/export haut/bas',
        defaultParametric: 'Calculer paramétrisation',
        show_legend_free_value: 'Valeur contenue dans un intervalle',
        legend_dashed_links: 'Valeur du flux inconnu',
        hide_leg: 'Masquer la légende',
        show_leg: 'Afficher la légende',
        tooltips: {
          Echelle: 'Modifier l\'échelle des flux et noeuds',
          MaxFlux: 'Modifier la taille maximale (en pixel) pour l\'affichage des flux',
          MinFlux: 'Modifier la taille minimale (en pixel) pour l\'affichage des flux',
          TCG: 'Taille des carreaux de la grille de fond (en pixel)',
          MN: 'Les noeuds déplacés bougent par "marche" au lieux de suivre continuellement la souris',
          SLIP: 'Active/désactive l\'affichage de la légende quand les palettes de couleurs des étiquettes sont affichées',
          GV: 'Activer ou désactiver l\'affichage de la grille de fond',
          AN: 'Arrangement automatiquement les noeuds : ie venir coller le coin supérieur gauche des noeuds sur le coin de grille le plus proche',
          EEN_h: 'Ecart horizontal par défaut (en pixel) entre les noeuds pour un positionnement automatique',
          EEN_v: 'Ecart vertical par défaut (en pixel) entre les noeuds pour un positionnement automatique',
          PA: 'Réaliser un positionnement automatique des noeuds en fonction des écarts par défaut spécifiés',
          BgC: 'Changer la couleur fond de l\'espace graphique interactif',
          factExpH: 'Modifie le facteur d\'expansion horizontale : l\'application du facteur multplie l\'écart horizontale de chaque noeuds par rapport à celui le plus à gauche par le facteur de l\'input',
          factExpV: 'Modifie le facteur d\'expansion verticale : l\'application du facteur multplie l\'écart verticale de chaque noeuds par rapport à celui le plus haut par le facteur de l\'input',
          reInitDY: 'Réinitialiser',
          columnsParameters: 'Paramètres des colonnes',
          positioningMode: 'Mode de positionnement',
          autoX: 'Positionnement horizontal automatique',
          parametricMode: 'Intervalles verticaux constants',
          absoluteMode: 'Points d\'ancrages fixes',
          importExport: 'Noeuds imports exports',
          importExportClose: 'Import Export près du noeud',
          importExportAboveBelow: 'Import Export en haut et bas du diagramme',
        }
      },
      Tags: {
        Nom: 'Nom',
        Leg: 'Légende',
        tags: 'Étiquette',
        Bannière: 'Type',
        Position: 'Position',
        Unique: 'Unique',
        Multiple: 'Multiple',
        Unit: 'Unités',
        Niveau: 'Niveau',
        Visible: 'Visible',
        Couleur: 'Couleur',
        Forme: 'Forme',
        GE: 'Groupe',
        EGE: 'Groupes',
        EEG: 'Etiquettes',
        Dimension: 'Dimension',
        EditDimension: 'Édition des dimensions',
        EditDimensionLevel: 'Édition des niveaux d\'une dimension',

        selct: 'Sélectionné',
        tooltips: {
          pal: 'Appliquer une palette de couleurs aléatoires pour les étiquettes du groupe sélectionné',
          pal_shuffle: 'Changer l\'ordre des couleur appliquées aux étiquettes du groupe sélectionné',
          pal_std: 'Choisir une palette de couleurs standard pour les étiquettes du groupe sélectionné',
          add: 'Ajouter une étiquette au groupe sélectionné',
          add_grp: 'Ajouter un groupe d\'étiquette',
          rm: 'Supprimer l\'étiquette',
          rm_grp: 'Supprimer ce groupe d\'étiquette',
          nom: 'Renommer l\'étiquette courante',
          nom_grp: 'Renommer ce groupe d\'étiquette',
          leg_grp: ' Active ou non la légende sur le filtrage de ce groupe d\'étiquettes et donc les couleurs associées aux étiquettes de ce groupe',
          visible: 'Choisir de rendre visible ou non les noeuds associés à cette étiquette',
          couleur: 'Changer la couleur de l\'étiquette courante',
          forme: 'Choisir la forme des noeuds associés à cette étiquette',
          banner: 'Choisir le type de menu déroulant sur le filtrage de ce groupe d\'étiquettes (Aucun / Unique / multiple / LevelTags)',
          up: 'Monter le groupe d\'étiquettes dans le menu de filtrage des noeuds',
          down: 'Descendre le groupe d\'étiquettes dans le menu de filtrage des noeuds'
        }
      },
      Label: {
        value_title: 'Valeur',
        name_title: 'Label',
        police: 'Police',
        size: 'Taille',
        bold: 'Gras',
        italic: 'Italic',
        uppercase: 'Majuscule',
        align_v: 'Position vert.',
        align_h: 'Position horiz.',
        color: 'Couleur',
        scientificNotation: 'Notation scientifique',
        significantDigits: 'Chiffres significatifs',
        value_label_custom_digit: 'Décimales',
        NbDigit: 'Nombre maximum de décimales',
        unit: 'Unité',
        unit_name: 'Nom de l\'unité',
        unit_factor: 'Facteur d\'unité'
      },
      Banner: {
        unitary_view: 'Vues',
        title_data_type: 'Données affichées',
        data: 'Données',
        filter: 'Filtres',
        fdf: 'Filtrage des flux',
        fdn: 'Légende et filtres',
        ndd: 'Hiérarchies',
        ndd_one: 'Hiérarchie',
        ndd_lst: 'Groupes d\'étiquettes',
        ndd_chk: 'Appliquer les couleurs associées',
        sdr: 'Type de données affichées',
        sdd: 'Sélection des données',
        tl: 'Téléchargements',
        rslt: 'Téléchargement résultats',
        p_aff: 'Paramètres d\'affichage',
        p_aff_aff_links: 'Paramètres d\'affichage des flux',
        p_aff_filtre_links: 'Paramètres de filtrage visuel des flux',
        type_value: 'Type de valeur des flux',
        structure: 'Structure',
        collected_data: 'Collectées',
        collected_data_label: 'Calculées, libellé collectées',
        reconciled: 'Calculées',
        only_data: 'Valeurs',
        free_interval: 'Intervalles',
        free_value: 'Valeurs possible',
        indetermined_value: 'Affichage des intervalles',
        filtre: 'Seuil pour l\'affichage des flux',
        fl: 'Seuil pour l\'affichage des labels',
        fn: 'Flux nuls visibles',
        visible: 'Visible',
        hlp_1: 'Les diagrammes de Sankey',
        hlp_1_txt_2: 'Choisir le niveau d\'agrégation du diagramme',
        hlp_1_txt_3: 'Des filtres peuvent être utilisés pour n\'afficher que des parties du diagramme. Pour cela utiliser les selecteurs',
        hlp_1_txt_4: 'Différents palettes de couleurs peuvent être utiliser pour colorer les noeuds et les flux en utilisant le sélecteur Palette de Couleurs',
        hlp_1_txt_5: 'La structure du diagramme (sans épaisseur de flux) peut être affiché en cochant Structure du diagramme',
        hlp_1_txt_6: 'Le diagramme peut être ajusté à l\'écran en cochant Ajuster à l\'écran',
        hlp_1_txt_7: 'Pour obtenir des informations sur chaque flux, appuyer sur shift et passer la souris sur le flux.',
        hlp_1_txt_8: 'Paramétrer l\'affichage',
        hlp_1_txt_9: 'Menu déroulant pour filtrer les noeuds/flux/données selon leur groupe d\'étiquette associée ou bien pour appliquer des couleurs au diagramme avec la palette de couleurs du groupe d\'étiquette.',
        tooltipAdjustH: 'Réajuster horizontalement la zone de dessin à la taille de l\'écran',
        tooltipAdjustV: 'Réajuster verticalement la zone de dessin à la taille de l\'écran',
        tooltipTranspose: 'Transposer le diagramme : inverser les axes horizontal et vertical',
        tooltipStructure: 'Paramétrage visuel de la structure du diagramme',
        tooltipSelection: 'Sélectionnez ou déplacez un élément',
        tooltipHelp: 'Affichez le dialogue d\'aide',
        posMode_parametric: 'Mode écart vertical constant',
        posMode_absolute: 'Mode coordonnées absolues',
        tooltipLiason: 'Permet de sélectionner le mode édition pour dessiner noeuds et flux ou le mode sélection pour sélectionner noeuds et flux afin de changer leurs attributs.',
        select_sibling: 'Selectionner ses frères ',
        fullscreen: 'Passer en mode mode plein écran',
        quit_fullscreen: 'Quitter le mode plein écran',
        hlp_node_tag_filter: 'Filtrer les noeuds et appliquer la couleur des étiquettes',
        hlp_link_tag_filter: 'Filtrer les flux et appliquer la couleur des étiquettes',
        hlp_data_tag_filter: 'Choisir les données et appliquer la couleur des étiquettes',
        open_configuration_menu: 'Ouvrez le menu de configuration.'
      },
      useTemplate: 'Utiliser ce modèle',
      DisplayWelcome: 'Accueil',
      dontSeeAgain: 'Ne plus montrer',
      scale: 'Échelle',
      useTutoJSON: 'Ouvrir',
      useTutoExcel: 'Ouvrir Excel',
      menuTuto: 'Ouvrir menu tutoriel',
      desire_to_know_more: 'En savoir +',
      contribute_to_os: 'En savoir +',
      legal: 'Mentions légales',
      tdr: 'Tous droits réservées',
      fullscreen: 'Activer le mode plein écran',
      exitFullscreen: 'Quitter le mode plein écran',
      Avancé: 'Avancé',
      separator_interval: ';',
      sep_decimal: ',',
      diaporama: 'Présentation',
      start: 'Démarrer',
      tooltip: {
        dontSeeAgain: 'En cochant cette case il n\'y aura plus d\'écran d\'accueil au prochaine chargement de la page. Pour réafficher cet accueil aller dans Aide->Accueil.',
        diaporama: 'Présentation des différentes fonctionnalités de l\'outil des plus basiques aux plus avancées, ainsi que les combinaisons souris/claviers d\'édition.',
        start: 'Commencez à tracer vos flux. Pour cela cliquez dans la zone de dessin, faites glisser sans relâcher, puis relâchez.'
      },
      color_lock: {
        locked: 'Couleur personnalisée — cette couleur est fixée et ne sera pas remplacée par la couleur propre de l\'élément',
        unlocked: 'Hérite la couleur propre de l\'élément (nœud, flux ou zone de texte) — cliquez pour verrouiller une couleur personnalisée'
      }
    }
  }
}
